import cn from 'classnames';

export const SelectOption = ({ item, isSelected, isMulti, onClick }) => {
  const handleClick = e => {
    e.stopPropagation();
    onClick(item);
  };

  return (
    <li
      role="option"
      aria-selected={isSelected}
      onClick={handleClick}
      className={cn(
        'flex items-center gap-2 px-3 py-1.5 text-sm cursor-pointer select-none',
        'hover:bg-[#f5f5f5]'
      )}
    >
      {isMulti && (
        <input
          type="checkbox"
          readOnly
          checked={isSelected}
          className="pointer-events-none"
        />
      )}
      <span>{item.title}</span>
    </li>
  );
};
